import axios from 'axios';
import xhrRoutes from './routes/xhr';
import Translator from './translator';
import userDemote from './user-demote';
import stringifyObject from '../helpers/stringify-object';
import giveTranslation from './give-translations';

const fn = {
  classUserCardInactive: 'user__item__card--inactive',
  classUserAdmin: 'user__item__card--admin',
  init: () => {
    const route = xhrRoutes.community.promote;
    const userPromoteItems = document.querySelectorAll('.js-user-promote');
    let clicked = false;

    if (!userPromoteItems.length) {
      return;
    }

    [].forEach.call(userPromoteItems, (userPromoteItem) => {
      userPromoteItem.addEventListener('click', (e) => {
        const communityId = userPromoteItem.getAttribute('data-community-id');
        const userId = userPromoteItem.getAttribute('data-user-id');

        if (!userId || !communityId || clicked) {
          return;
        }

        e.preventDefault();

        if (!confirm(giveTranslation('api.confirm.user.promote'))) {
          return;
        }

        clicked = true;

        const communityUser = document.querySelector(`[data-community-user="${communityId}_${userId}"]`);
        communityUser.querySelector('.user__item__card').classList.add(fn.classUserCardInactive);

        route.params.community_id = communityId;
        route.params.user_id = userId;

        axios.post(route.url, stringifyObject(route.params))
          .then((response) => {
            if (response.data.status === 'fail') {
              fn.removeInactiveClass(communityUser.querySelector('.user__item__card'));
              fn.showNotification('error', Translator.trans('api.error.fail'));
            } else {
              fn.removeInactiveClass(communityUser.querySelector('.user__item__card'));
              fn.showNotification('success', Translator.trans('api.community.user.message.promoted'));
              fn.addAdmin(userPromoteItem, communityUser, userId);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .then(() => {
            // always executed
          });
      });
    });
  },

  /**
   * Show notification after the response
   *
   * @param type
   * @param message
   */
  showNotification: (type, message) => {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add('notification--' + type);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  },

  /**
   * @param userPromoteItem
   * @param communityUser
   * @param userId
   */
  addAdmin: (userPromoteItem, communityUser, userId) => {
    userPromoteItem.classList.add('user__item__action--demote');
    userPromoteItem.classList.add('js-user-demote');

    userPromoteItem.classList.remove('user__item__action--promote');
    userPromoteItem.classList.remove('js-user-promote');

    const adminBadge = document.createElement('div');
    adminBadge.classList.add('user__item__admin');
    adminBadge.setAttribute('data-admin-user-id', userId);
    adminBadge.innerHTML = '<svg width="20" height="20" class="user__icon__admin"><use xlink:href="/build/web/svg/symbol/svg/sprite.symbol.svg#icon-user-admin"></use></svg>';

    communityUser.querySelector('.user__data').appendChild(adminBadge);
    communityUser.querySelector('.user__item__card').classList.add(fn.classUserAdmin);
    userDemote.init();
  },

  /**
   * @param element
   */
  removeInactiveClass: (element) => {
    element.classList.remove(fn.classUserCardInactive);
  },
};

export default fn;
